import { SelectProps } from '@mui/material';
import { JobType, ThresholdJob } from 'interfaces/job';
import React, { ReactElement } from 'react';
import JobSelect, { JobSelectProps } from './JobSelect';

interface ThresholdJobSelectProps extends Omit<SelectProps, 'onScroll' | 'label'> {
  selectedThresholdJobId: string | null;
  setSelectedThresholdJobId: (jobId: string | null) => void;
  restoredJobOrchestrationId?: string | null;
  onLoadFullJob: (job: ThresholdJob) => void;
  autoAssignLastJob?: boolean;
  helperText?: string;
  studyId?: string;
  errors?: JobSelectProps['errors'];
  field?: JobSelectProps['field'];
}

export const ThresholdJobSelect = ({
  selectedThresholdJobId,
  setSelectedThresholdJobId,
  restoredJobOrchestrationId,
  onLoadFullJob,
  autoAssignLastJob,
  helperText,
  studyId,
  errors,
  field,
}: ThresholdJobSelectProps): ReactElement => {
  return (
    <JobSelect
      label="Threshold Job"
      jobType={JobType.MultiplexThreshold}
      selectedJobId={selectedThresholdJobId}
      setSelectedJobId={setSelectedThresholdJobId}
      orchestrationIds={
        !selectedThresholdJobId && restoredJobOrchestrationId ? [restoredJobOrchestrationId] : undefined
      }
      onLoadFullJob={onLoadFullJob}
      errors={errors}
      field={field || 'thresholdJob'}
      autoAssignLastJob={autoAssignLastJob || Boolean(!selectedThresholdJobId && restoredJobOrchestrationId)}
      helperText={helperText}
      studyId={studyId}
    />
  );
};
